const getters = {
  get_escuela: (state) => {
    return state.escuela_data;
  },

  get_escuela_select: (state) => {
    return state.escuela_data.map((item) => {
      return { id: item.id, nombre: item.nombre };
    });
  },
};

export default getters;
